import React from 'react';
import { FormScopeProvider } from '@de/providers/FormScopeContext';
import {
  FORM_COMPONENT_TYPE,
  readFormName,
} from '@de/utils/configurable-step/findBoundComponent';
import { warnOnce } from '@de/utils/warnOnce';

const WARN_ONCE_NAMESPACE = 'platform-form';

export interface PlatformFormProps {
  readonly name?: unknown;
  readonly children?: React.ReactNode;
}

/**
 * Plain container that scopes the lead fields and `lead.submit` buttons inside
 * it to one form `name`. It renders a `div`, not a native `<form>`.
 */
export const PlatformForm: React.FC<PlatformFormProps> = ({
  name,
  children,
}) => {
  const formName = readFormName(FORM_COMPONENT_TYPE, { name });
  if (formName === undefined) {
    // A non-blank name that was refused is already reported by `readFormName`.
    if (typeof name !== 'string' || name.trim().length === 0) {
      warnOnce(
        WARN_ONCE_NAMESPACE,
        '[platform.form] Missing or blank name; the fields inside are not scoped to a form',
      );
    }
    return <div>{children}</div>;
  }
  return (
    <div>
      <FormScopeProvider name={formName}>{children}</FormScopeProvider>
    </div>
  );
};
